class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;
    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }
  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }
  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();
    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }
  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}
customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.megaMenuContent = this.mainDetailsToggle.querySelector('.mega-menu__content');
    this.onHover();
  }

  onHover() {
    if (this.mainDetailsToggle.classList.contains('mega-menu')) {
      // Variable to track if we're hovering on the menu or its content
      let isHovering = false;

      // When hovering the main menu button
      this.mainDetailsToggle.addEventListener('mouseover', () => {
        isHovering = true;
        this.mainDetailsToggle.setAttribute("open", true);
        this.mainDetailsToggle.setAttribute('aria-expanded', true);
      });

      // When hovering the dropdown content
      if (this.megaMenuContent) {
        this.megaMenuContent.addEventListener('mouseover', () => {
          isHovering = true;
          this.mainDetailsToggle.setAttribute("open", true);
          this.mainDetailsToggle.setAttribute('aria-expanded', true);
        });
      }

      // When leaving either element
      this.mainDetailsToggle.addEventListener('mouseout', (e) => {
        // Check if we're still within the parent element or moving to the content
        const relatedTarget = e.relatedTarget;
        if (!this.mainDetailsToggle.contains(relatedTarget) && 
            relatedTarget !== this.megaMenuContent) {
          isHovering = false;
          // Small delay to prevent flickering
          setTimeout(() => {
            if (!isHovering) {
              this.mainDetailsToggle.removeAttribute('open');
              this.mainDetailsToggle.setAttribute('aria-expanded', false);
            }
          }, 100);
        }
      });

      // If we leave the mega menu content
      if (this.megaMenuContent) {
        this.megaMenuContent.addEventListener('mouseout', (e) => {
          // Check if we're moving back to the menu or completely away
          const relatedTarget = e.relatedTarget;
          if (!this.mainDetailsToggle.contains(relatedTarget) && 
              relatedTarget !== this.mainDetailsToggle) {
            isHovering = false;
            setTimeout(() => {
              if (!isHovering) {
                this.mainDetailsToggle.removeAttribute('open');
                this.mainDetailsToggle.setAttribute('aria-expanded', false);
              }
            }, 100);
          }
        });
      }
    }
  }
  
  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;
    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}
customElements.define('header-menu', HeaderMenu);